import React, { useState } from "react";
import { Check, Copy } from "lucide-react";
import { toast } from "sonner";

export const inputCls = "w-full bg-white border border-clay-300 px-3 py-2 text-sm outline-none focus:border-terracotta font-sans";
export const btnDark = "inline-flex items-center gap-2 px-4 py-2 bg-clay-900 text-white text-[12px] tracking-wider uppercase hover:bg-terracotta disabled:opacity-50";
export const btnLight = "inline-flex items-center gap-2 px-4 py-2 border border-clay-300 text-clay-800 text-[12px] tracking-wider uppercase hover:border-clay-900 disabled:opacity-50";

export const fmtWhen = (iso) => (iso ? new Date(iso).toLocaleString("es-ES", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");

export function Card({ title, kicker, children, testid }) {
  return (
    <section className="border border-clay-300 bg-white p-6" data-testid={testid}>
      <div className="smallcaps">{kicker}</div>
      <h2 className="font-serif text-2xl mt-1 mb-5">{title}</h2>
      <div className="space-y-4">{children}</div>
    </section>
  );
}

export function Field({ label, hint, children }) {
  return (
    <label className="block">
      <span className="text-[12px] text-clay-700 block mb-1">{label}</span>
      {children}
      {hint && <span className="text-[11px] text-clay-500 block mt-1">{hint}</span>}
    </label>
  );
}

export function CopyButton({ text, testid, label = "Copiar" }) {
  const [done, setDone] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setDone(true);
      setTimeout(() => setDone(false), 1500);
    } catch (e) { toast.error("No se pudo copiar"); }
  };
  return (
    <button type="button" onClick={copy} data-testid={testid} className={btnLight}>
      {done ? <Check size={12}/> : <Copy size={12}/>} {done ? "Copiado" : label}
    </button>
  );
}

export function CodeBlock({ children, testid }) {
  return (
    <pre data-testid={testid} className="bg-clay-900 text-clay-100 text-[11.5px] leading-relaxed p-4 overflow-x-auto whitespace-pre-wrap break-all font-mono">
      {children}
    </pre>
  );
}
